// `localStorage` object may exist, but the API may not be available.
// Browsers offer settings that disable localStorage, like incognito mode.
// Checking will avoid throwing a bunch of errors.
const storageAvailable = (
  type: "localStorage" | "sessionStorage" = "localStorage"
) => {
  let storage: Storage | undefined
  try {
    storage = window[type]

    const x = "__storage_test__"
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage !== undefined &&
      storage.length !== 0
    )
  }
}

export { storageAvailable }
